export const allowedLocales = {
  uk: "uk",
  en: "en",
  ru: "ru",
} as const;